import {Component, input} from '@angular/core';

@Component({
  selector: 'app-add-animal-svg',
  imports: [],
  templateUrl: './add-animal-svg.component.html',
  styleUrl: './add-animal-svg.component.css'
})
export class AddAnimalSvgComponent {
  
  color = input('#217DD9');
}
